import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import useSWR from "swr";
import { URLS } from "../../../services/urls";
import _ from "lodash";
import { getQuantity } from "../../../components/utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faLayerGroup, faUndo, faFilter } from "@fortawesome/free-solid-svg-icons";
import "./styleCard.css"; // Créez ce fichier ou ajoutez le CSS à Home.css

const SearchFilter = ({ locations, searchResults, count }) => {
  const { t } = useTranslation();
  let [searchParams, setSearchParams] = useSearchParams();

  // Fetch des catégories
  const { data: categories, isLoading: loadingCategories } = useSWR(
    URLS.CONFIGS.PROFILE.SECTOR.list("")
  );

  // --- HANDLERS ---

  const handleChangeIndustry = (id) => {
    // On crée une copie des params existants pour ne pas perdre le reste
    const newParams = new URLSearchParams(searchParams);
    
    if (id === "") {
        newParams.delete("industry"); // Si "Tout", on retire le filtre
    } else {
        newParams.set("industry", id);
    }
    
    // On garde la recherche et la location, on reset la page si besoin (géré par le parent)
    setSearchParams(newParams);
  };

  const handleChangeLocation = (e) => {
    const name = e.target.value;
    const newParams = new URLSearchParams(searchParams);
    
    if (name === "") {
        newParams.delete("location");
    } else {
        newParams.set("location", name);
    }
    setSearchParams(newParams);
  };

  const handleReset = () => {
    setSearchParams({}); // Vide tout
  };

  // Récupération des valeurs actuelles
  const currentIndustry = searchParams.get("industry");
  const currentLocation = searchParams.get("location");

  return (
    <div className="sidebar-filter-card bg-white p-4 rounded-4 shadow-sm border">
      
      {/* En-tête Filtres */}
      <div className="d-flex justify-content-between align-items-center mb-4 pb-3 border-bottom">
        <h5 className="fw-bold mb-0 text-dark">
            <FontAwesomeIcon icon={faFilter} className="me-2 text-primary" />
            {t("textAdvanceFilter") || "Filtres"}
        </h5>
        {(currentIndustry || currentLocation) && (
            <button 
                onClick={handleReset} 
                className="btn btn-link text-danger text-decoration-none btn-sm p-0 font-xs"
            >
                <FontAwesomeIcon icon={faUndo} className="me-1" />
                {t("textReset") || "Effacer"}
            </button>
        )}
      </div>

      {/* --- FILTRE LOCALISATION --- */}
      <div className="filter-group mb-4">
        <label className="form-label fw-bold text-muted small mb-2">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
            {t("textLocation") || "Localisation"}
        </label>
        <div className="custom-select-wrapper">
            <select 
                className="form-select form-select-modern" 
                value={currentLocation || ""} 
                onChange={handleChangeLocation}
            >
                <option value="">Toutes les villes</option>
                {locations?.map((loc) => (
                    <option key={loc.id} value={loc.name}>
                        {loc.name}
                    </option>
                ))}
            </select>
        </div>
      </div>

      {/* --- FILTRE INDUSTRIE --- */}
      <div className="filter-group">
        <label className="form-label fw-bold text-muted small mb-3">
            <FontAwesomeIcon icon={faLayerGroup} className="me-2" />
            {t("textIndustry") || "Secteur d'activité"}
        </label>

        <div className="industry-list">
            
            {/* Option "Tout" */}
            <div className="form-check d-flex justify-content-between align-items-center mb-2">
                <div>
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="ind-all"
                        checked={!currentIndustry}
                        onChange={() => handleChangeIndustry("")}
                        style={{cursor: 'pointer'}}
                    />
                    <label className="form-check-label ms-2 small cursor-pointer" htmlFor="ind-all">
                        {t("textAll") || "Tous les secteurs"}
                    </label>
                </div>
                <span className="badge bg-light text-muted border rounded-pill">{count}</span>
            </div>

            {/* Liste des catégories */}
            {!loadingCategories &&
                _.orderBy(categories?.results, ["jobs.length"], ["desc"])
                ?.slice(0, 8) // On limite à 8 pour ne pas avoir une liste infinie
                ?.map((cat) => {
                    // Calcul du nombre (si la fonction getQuantity fonctionne comme prévu)
                    // Sinon on utilise cat.jobs.length par défaut
                    const qty = getQuantity(
                        cat, 
                        searchResults, 
                        cat?.jobs?.length, 
                        currentLocation || currentIndustry || searchParams.get("search")
                    );

                    // On n'affiche que s'il y a des jobs (optionnel)
                    if (cat?.jobs?.length === 0) return null;

                    return (
                        <div key={cat.id} className="form-check d-flex justify-content-between align-items-center mb-2">
                            <div className="text-truncate me-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`ind-${cat.id}`}
                                    checked={currentIndustry === cat.id.toString()}
                                    onChange={() => handleChangeIndustry(cat.id)}
                                    style={{cursor: 'pointer'}}
                                />
                                <label 
                                    className="form-check-label ms-2 small cursor-pointer text-truncate" 
                                    htmlFor={`ind-${cat.id}`}
                                    title={cat.name}
                                >
                                    {cat.name}
                                </label>
                            </div>
                            <span className="badge bg-light text-muted border rounded-pill flex-shrink-0">
                                {qty}
                            </span>
                        </div>
                    );
            })}
        </div>
      </div>

    </div>
  );
};

export default SearchFilter;